import React from 'react';
import { Grid, Box } from '@mui/material';
import { Product, LiquidityPeriodBalanceType } from '../../../interfaces/DTO/mislaka_xml_models';
import { GroupByHandlerPieChart } from './GroupByHandlerPieChart';
import GroupByProductTypeOrHandlerPieChart from './GroupByProductTypeOrHandlerPieChart';
import { LOCAL_STORAGE_KEYS } from '../../../services/local_storage_keys';

interface ProductDistributionChartsProps {
  products: Product[];
}

const ProductDistributionCharts: React.FC<ProductDistributionChartsProps> = ({ products }) => {
  return (
    <Grid container spacing={2}>
      {/* צד ימין – תרשים סה"כ */}
      <Grid item xs={12} md={8}>
        <GroupByProductTypeOrHandlerPieChart
          products={products}
          storageKey={LOCAL_STORAGE_KEYS.mimshakHierarchyView_group_by_chart}
        />
      </Grid>

      {/* צד שמאל – שלושה תרשימים קטנים */}
      <Grid item xs={12} md={4}>
        <Box display="flex" flexDirection="column" gap={1}>
          <GroupByHandlerPieChart
            products={products}
            balanceType={LiquidityPeriodBalanceType.CAPITAL}
            showLegend={false}
          />
          <GroupByHandlerPieChart
            products={products}
            balanceType={LiquidityPeriodBalanceType.PAYING_PENSION}
            showLegend={false}
          />
          <GroupByHandlerPieChart
            products={products}
            balanceType={LiquidityPeriodBalanceType.NON_PAYING_PENSION}
            showLegend={false}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ProductDistributionCharts;
